import Image from "next/image";
import Link from "next/link";
import { cn } from "@/lib/utils";
import logoLight from "@/public/images/kautious.png";
import logoDark from "@/public/images/kautious-white.png";

interface LogoProps {
  className?: string;
  /** Rendered height. Width follows the image's aspect ratio. */
  size?: "sm" | "md";
}

/**
 * Wordmark that links home. Both colourways are rendered and swapped with
 * CSS on the `dark` class, so there is no theme flash and no hydration gate.
 */
export const Logo = ({ className, size = "md" }: LogoProps) => {
  const height = size === "sm" ? "h-6" : "h-7";
  return (
    <Link
      href="/"
      aria-label="Kautious home"
      className={cn("inline-flex shrink-0 items-center", className)}
    >
      <Image
        src={logoLight}
        alt="Kautious"
        priority
        className={cn(height, "w-auto dark:hidden")}
      />
      <Image
        src={logoDark}
        alt=""
        aria-hidden
        priority
        className={cn(height, "hidden w-auto dark:block")}
      />
    </Link>
  );
};
